import React from 'react';
import { Building2Icon, HomeIcon, BriefcaseIcon } from 'lucide-react';
const ServiceIntro = () => {
  return <section id="services" className="py-16 bg-white" data-id="element-340">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-341">
        <div className="text-center mb-16" data-id="element-342">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-343">
            清掃サービスのご案内
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-344">
            ジャパンクリーニングセンターは、全国主要都市で高品質な清掃スタッフを提供しております。
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-345">
          <div className="bg-blue-50 p-8 rounded-lg shadow-sm hover:shadow-md transition-shadow" data-id="element-346">
            <div className="bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center mb-6" data-id="element-347">
              <Building2Icon className="h-8 w-8 text-blue-600" data-id="element-348" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-349">ホテル清掃</h3>
            <p className="text-gray-700" data-id="element-350">
              ホテル業界基準に準拠した清掃サービスを提供。客室の清掃、ベッドメイク、バスルーム清掃、備品補充まで一貫して対応いたします。
            </p>
          </div>
          <div className="bg-blue-50 p-8 rounded-lg shadow-sm hover:shadow-md transition-shadow" data-id="element-351">
            <div className="bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center mb-6" data-id="element-352">
              <HomeIcon className="h-8 w-8 text-blue-600" data-id="element-353" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-354">
              民泊施設清掃
            </h3>
            <p className="text-gray-700" data-id="element-355">
              Airbnbなどの民泊施設向けに、迅速な清掃サービスを提供。チェックアウトからチェックインまでの短時間での対応が可能です。
            </p>
          </div>
          <div className="bg-blue-50 p-8 rounded-lg shadow-sm hover:shadow-md transition-shadow" data-id="element-356">
            <div className="bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center mb-6" data-id="element-357">
              <BriefcaseIcon className="h-8 w-8 text-blue-600" data-id="element-358" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-359">
              オフィス清掃
            </h3>
            <p className="text-gray-700" data-id="element-360">
              快適なビジネス環境を維持するための総合的な清掃サービス。共用部分、デスク周り、会議室など、オフィス全体の衛生管理を行います。
            </p>
          </div>
        </div>
        <div className="mt-16 text-center" data-id="element-361">
          <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-362">
            サービス提供エリア
          </h3>
          <div className="flex flex-wrap justify-center gap-4" data-id="element-363">
            <span className="bg-gray-100 text-gray-800 px-4 py-2 rounded-full" data-id="element-364">
              東京
            </span>
            <span className="bg-gray-100 text-gray-800 px-4 py-2 rounded-full" data-id="element-365">
              大阪
            </span>
            <span className="bg-gray-100 text-gray-800 px-4 py-2 rounded-full" data-id="element-366">
              京都
            </span>
            <span className="bg-gray-100 text-gray-800 px-4 py-2 rounded-full" data-id="element-367">
              福岡
            </span>
            <span className="bg-gray-100 text-gray-800 px-4 py-2 rounded-full" data-id="element-368">
              名古屋
            </span>
            <span className="bg-gray-100 text-gray-800 px-4 py-2 rounded-full" data-id="element-369">
              札幌
            </span>
          </div>
        </div>
      </div>
    </section>;
};
export default ServiceIntro;